/**
 * The one rule for "does this user hold these permissions", used by `$has` (utils/index.js) and by
 * `can(capability, store)` (actions/permissions.js), so a button and a UI tool always agree.
 * No imports, so `npm run test:unit` (node --test) can load it directly.
 */

/** A required key that every user passes. */
export const PERMISSION_ANY_USER = 'All';

/** Every permission name the user's roles grant. */
function grantedNames(user) {
  const roles = user.roles && user.roles.length > 0 ? user.roles : [];
  return roles.flatMap((role) => role.permissions || []).map(({ name }) => name);
}

/**
 * @param {object|null} user the signed-in user (`roles[].permissions[].name`)
 * @param {string|string[]} required one key, or several
 * @param {boolean} [any] true: one of the keys is enough; false: every key is needed
 * @returns {boolean} false for no user and for no keys
 */
export function userHasPermissions(user, required, any = false) {
  const keys = required && typeof required === 'string' ? [required] : required;
  if (!user) return false;
  const granted = grantedNames(user);
  let pass = false;
  if (keys && Array.isArray(keys)) {
    keys.every((key) => {
      pass = granted.includes(key) || key === PERMISSION_ANY_USER;
      return any ? !pass : pass;
    });
  }
  return pass;
}
